import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import HomeUI from './Home';
import './Home.css';
import { useCookies } from '../../hooks/useCookies';
import { useProfile } from "../../components/userflow/components/context/ProfileContext";
import { handleUserNavigation } from "../../utils/handleUserRedirect"
import Loader from '../../components/Utility/Loader';


export const Home = () => {
  const navigate = useNavigate();
  // const [mobile, setMobile] = useState(false); // Mobile state handled internally by LandingPageNew
  const { getCookie } = useCookies();
  const [loading, setLoading] = useState(false);

  const token = getCookie('token')
  const userId = getCookie('userId')
  const { fetchProfile } = useProfile();

  const handleRouting = useCallback(async () => {
    const success = await fetchProfile();
    const result = success.data;

    if (!success.ok) return;
    if (result) {
      if (!result?.Email || result?.Email === "") {
        navigate("/emailverify");
      } else if (result?.Email) {
        await handleUserNavigation(result, navigate, setLoading, "");
      }
    } else {
      setLoading(false);
    }

  }, [fetchProfile, navigate, setLoading]);


  useEffect(() => {
    // Redirect to another URL
    if (token && userId) {
      handleRouting()
    }
    else {
      // navigate("/"); // Don't redirect to / if we are already on the landing page (implied)
      // This logic seems to prevent infinite loops if LP is the route for "/"
    }
  }, [token, userId, handleRouting, navigate]);

  // Mobile check removed as LandingPageNew handles responsiveness
  
  if (loading) {
    return <Loader />;
  }
  return (
    <div className="home-mainbox">
      <HomeUI />
    </div>
  );
}

